import { render, staticRenderFns } from "./OmniButton.vue?vue&type=template&id=6fe10018&"
import script from "./OmniButton.vue?vue&type=script&lang=js&"
export * from "./OmniButton.vue?vue&type=script&lang=js&"
import style0 from "./OmniButton.vue?vue&type=style&index=0&id=6fe10018&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports